import { createSlice } from '@reduxjs/toolkit';
import { DetailedAlert } from '../../utils/DetailedAlert';
import { ProductionSiteCalendar } from '../models/ProductionSiteCalendarModel';

export interface ProductionSiteCalendarData {
    productionSiteCalendar: ProductionSiteCalendar | null,
    nrApiCallsInProgress: number,
    alert: DetailedAlert | null,
};

const initialProductionSiteCalendarState: ProductionSiteCalendarData = {
    productionSiteCalendar: null,
    nrApiCallsInProgress: 0,
    alert: null,
};

export const callTypes = {
    get: 'get',
    post: 'post',
    put: 'put',
    delete: 'delete'
};

export const productionSiteCalendarSlice = createSlice({
    name: 'productionSiteCalendar',
    initialState: initialProductionSiteCalendarState,
    reducers: {
        catchError: (state, action) => {
            state.alert = action.payload.alert;
            if (action.payload.callType === callTypes.get ||
                action.payload.callType === callTypes.post ||
                action.payload.callType === callTypes.put ||
                action.payload.callType === callTypes.delete) {
                state.nrApiCallsInProgress = Math.max(state.nrApiCallsInProgress - 1, 0);
            }
        },
        startCall: (state, action) => {
            state.alert = null;
            if (action.payload.callType === callTypes.get ||
                action.payload.callType === callTypes.post ||
                action.payload.callType === callTypes.put ||
                action.payload.callType === callTypes.delete) {
                state.nrApiCallsInProgress = state.nrApiCallsInProgress + 1;
            }
        },
        endCall: (state, action) => {
            state.alert = null;
            if (action.payload.callType === callTypes.get ||
                action.payload.callType === callTypes.post ||
                action.payload.callType === callTypes.put ||
                action.payload.callType === callTypes.delete) {
                state.nrApiCallsInProgress = Math.max(state.nrApiCallsInProgress - 1, 0);
            }
        },
        dismissAlert: (state) => {
            state.alert = null;
        },
        productionSiteCalendarFetched: (state, action) => {
            state.nrApiCallsInProgress = Math.max(state.nrApiCallsInProgress - 1, 0);
            state.alert = null;
            state.productionSiteCalendar = action.payload;
        },
    }
});